import { useState } from 'react'
import { styled, IconButton } from '@mui/material'
import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { useWindowHeight } from '$func/window.react-hook'
import { BottomDrawer } from '$common/bottom-drawer'
import { DebouncedUnControlledSearchInput } from '$common/input'
import { useIsDesktopSize } from '$common/react-hooks/layout'
import { CloseIcon } from '$common/icons'
import { t } from '$i18n'
import { JoinHallRequestList } from '$common/join-channel-requests/join-hall-request-list'
import { JOIN_CHANNEL_REQUEST_LIST_ITEM_HEIGHT } from '$common/join-channel-requests/join-hall-request-list-item'

const HEADER_HEIGHT = 66

interface Props {
  roomId: string
  isOpen?: boolean
}

export function JoinHallRequestListModal({ roomId, isOpen }: Props) {
  const isDesktop = useIsDesktopSize()
  const [searchQuery, setSearchQuery] = useState<string>('')

  const windowHeight = useWindowHeight()
  const maxListHeight = windowHeight * 0.6

  return (
    <BottomDrawer
      onClose={closeCurrentModal}
      className={isDesktop ? 'is-desktop' : ''}
      isOpen={!!isOpen}
    >
      <Header className={isDesktop ? 'is-desktop' : undefined}>
        {isDesktop && (
          <IconButton onClick={closeCurrentModal}>
            <CloseIcon sx={{ color: 'neutral700' }} />
          </IconButton>
        )}

        <StyledSearchInput
          placeholder={t('common.search')}
          onQueryChange={q => {
            setSearchQuery(q)
          }}
        />
      </Header>

      <JoinHallRequestList
        roomId={roomId}
        searchQuery={searchQuery}
        height={itemsCount =>
          Math.max(
            Math.min(
              maxListHeight,
              itemsCount * JOIN_CHANNEL_REQUEST_LIST_ITEM_HEIGHT,
            ),
            200,
          )
        }
      />
    </BottomDrawer>
  )
}

const Header = styled('div')`
  display: flex;
  gap: 8px;
  height: ${HEADER_HEIGHT}px;

  width: 100%;
  padding: 12px 16px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.neutral300};

  .is-desktop {
    padding-right: 8px;
  }
`

const StyledSearchInput = styled(DebouncedUnControlledSearchInput)`
  padding: 0;
  flex-grow: 1;
`
